import styled from "styled-components";

const CreateAndEditTrailContainer = styled.div``;

export { CreateAndEditTrailContainer };
